<template>
<div>
DOCUMENTO DI CONSEGNA
<h4> {{ document.description }} -  {{ document.documentType }} {{ document.number }} {{ document.date }}  - {{ document.create_at }}</h4>

</div>

</template>
<script>

import api                         from '@/api'

export default {    
  props: ['stockMovementId'],
  data () {
    return {
    

      document  : {},
      
      
    }
  },


created()
{ 
  this.getData()
  //console.log('CREATED')
},

methods:
{
  async getData()
  {
    
    const sp   = 'spOrderDeliveryDocument'
    const payload  = {'stockMovementId'   : this.stockMovementId ,sp}    
                  
     try{

       const res = await api.post(payload)
        
          if (res.status !== 200) 
          {
              throw new Error(res.data ||  res)
          }
          
          this.document = res.data.recordsets[0][0]

            
    }
    catch(err){
           
            //return 0
    }
 
  },

  
    
}
    
}    
</script>

<style scoped>
 
.bold {
  font-weight  : bolder;
  
}

h4 {
  color        :rgb(221, 98, 11) ;
  font-family  : 'Roboto Condensed';
  font-size    : 20px;
  font-weight  : bold;
}



</style>